import { useState } from 'react';

import { Accordion, AccordionItem } from '@frontend/components/ui/accordion';
import { Button } from '@frontend/components/ui/button';
import { SearchEmpty } from '@frontend/Search/Empty/SearchEmpty';
import { SearchEmptyLoading } from '@frontend/Search/Empty/SearchEmptyLoading';
import { Question } from '@frontend/shared/components/Question/Question';
import { useQuestionList } from '@frontend/shared/hooks/useQuestionList';

export function SearchBrowse({
  res,
  hasFilter,
}: {
  res: ReturnType<typeof useQuestionList>;
  hasFilter: boolean;
}) {
  const [selectedId, setSelectedId] = useState<string>('');
  const { loading, result } = res;
  const isEmpty = !loading && !res.error && !result?.questions?.length;
  const isNotEmpty = !!result?.questions.length;

  return (
    <>
      <p className="mt-8 text-xl">Saved answers · newest first</p>
      {loading && !result && <SearchEmptyLoading />}
      {res.error && (
        <p role="alert">Could not load answers. Please try again.</p>
      )}
      {isEmpty && <SearchEmpty hasFilter={hasFilter} />}
      {isNotEmpty && (
        <>
          <Accordion
            type="single"
            collapsible
            className="mb-4 mt-8"
            value={selectedId}
            onValueChange={(value) => {
              setSelectedId(value || '');
            }}
          >
            {result?.questions?.map((question) => (
              <AccordionItem
                key={question.id}
                value={question.id}
                className="border-none mt-1.5"
                data-id={question.id}
              >
                <Question
                  question={question}
                  isExpanded={selectedId === question.id}
                />
              </AccordionItem>
            ))}
          </Accordion>
        </>
      )}
      {result?.nextCursor && (
        <Button
          className="mt-6"
          variant="outline"
          disabled={loading}
          onClick={res.loadMore}
        >
          {loading ? 'Loading…' : 'Load more'}
        </Button>
      )}
    </>
  );
}
